@import "../use-bootstrap-mixins.scss";

.container {
  padding: 0 12px;

  @include media-breakpoint-up(md) {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .title {
    text-align: center;
    margin-top: 12px;
    margin-bottom: 10px !important;
    width: 100%;
    font-size: 22px;
    display: none;

    @include media-breakpoint-up(sm) {
      display: block;
      margin-top: 28px;
      font-size: 38px;
      margin-bottom: 24px !important;
    }
  }

  .display_selector {
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin: 8px 0;

    @include media-breakpoint-up(lg) {
      display: none;
    }

    .display_selector_button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px;
      border-radius: 14px;
      background-color: #f0f0f0;
      color: #495057;
      font-size: 16px;
      cursor: pointer;
      flex-grow: 1;
      transition: all 0.1s;

      &.active {
        background-color: $primary;
        color: $textColorOnPrimary;
      }

      &:hover {
        background-color: $primary;
        color: $textColorOnPrimary;
      }
    }
  }

  .row {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    height: calc(100vh - 150px);
    overflow-y: scroll;

    @include media-breakpoint-up(sm) {
      height: calc(100vh - 260px);
      overflow-y: initial;
    }

    @include media-breakpoint-up(md) {
      flex-direction: row;
      gap: 24px;
      padding: 0;
    }

    .col {
      position: absolute;
      background-color: #fff;
      width: 100%;
      height: 100%;

      @include media-breakpoint-up(lg) {
        position: relative;
        width: auto;
      }

      &:first-of-type {
        flex: 1;

        @include media-breakpoint-up(lg) {
          display: block !important;
        }
      }

      &:last-of-type {
        max-width: 100%;
        overflow-y: scroll;
        @include media-breakpoint-up(lg) {
          min-width: 350px;
        }
      }
    }

    .hide {
      display: none;

      @include media-breakpoint-up(lg) {
        display: block;
      }
    }

    .show {
      display: block;

      @include media-breakpoint-up(lg) {
        display: block;
      }
    }

    .visible {
      visibility: visible;

      @include media-breakpoint-up(lg) {
        visibility: visible;
      }
    }

    .hidden {
      visibility: hidden;

      @include media-breakpoint-up(lg) {
        visibility: visible;
      }
    }

    .zBelow {
      z-index: -1;

      @include media-breakpoint-up(lg) {
        z-index: 0;
      }
    }

    .zAbove {
      z-index: 1;

      @include media-breakpoint-up(lg) {
        z-index: 0;
      }
    }
  }

  .overlay {
    position: relative;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    div:first-of-type {
      z-index: 10 !important;
    }
  }
}
